export default __webpack_public_path__ + "static/media/blog1.ba4fb198.jpg";